precision highp float;

varying vec2 vUv;
varying float vWinkInfluence;

uniform vec2 uEyeCenter;
uniform float uEyeRadius;
uniform float uWinkVal;
uniform float uStrength;
uniform float uRatio;

void main() {
  vUv = uv;

  vec3 p = position;

  vec2 scaledUv = vec2(uv.x * uRatio, uv.y);
  vec2 scaledCenter = vec2(uEyeCenter.x * uRatio, uEyeCenter.y);

  float dist = distance(scaledUv, scaledCenter);

  float innerRadius = uEyeRadius * 0.2;
  float outerRadius = uEyeRadius;
  vWinkInfluence = 1.0 - smoothstep(innerRadius, outerRadius, dist);

  float direction = sign(uEyeCenter.y - uv.y);
  if (direction == 0.0) {
    direction = 1.0;
  }

  p.y += vWinkInfluence * uWinkVal * uStrength * direction;
  p.z += vWinkInfluence * uWinkVal * 0.05;

  gl_Position = projectionMatrix * modelViewMatrix * vec4(p, 1.0);
}